export default `<label class="sr-only info-button-label"></label>
<button type="button" class="info-button">
    <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="icon"
        aria-hidden="true"
    >
        <path
            d="M11.6256 8.24999C11.4031 8.24999 11.1856 8.18403 11.0006 8.06042C10.8156 7.9368 10.6714 7.7611 10.5862 7.55554C10.5011 7.34997 10.4788 7.12374 10.5222 6.90551C10.5656 6.68728 10.6728 6.48679 10.8301 6.32946C10.9874 6.17213 11.1879 6.06501 11.4061 6.0216C11.6243 5.97819 11.8505 6.00054 12.0561 6.08569C12.2617 6.17084 12.4374 6.31499 12.561 6.49999C12.6846 6.685 12.7506 6.90249 12.7506 7.12499C12.7503 7.42328 12.6317 7.70924 12.4208 7.92016C12.2099 8.13108 11.9239 8.24973 11.6256 8.24999Z"
            fill="#00325C"
        />
        <path
            d="M14.2506 17.25H13.5006C12.9041 17.2492 12.3322 17.0119 11.9105 16.5901C11.4887 16.1683 11.2514 15.5965 11.2506 15V11.25H10.5006C10.3017 11.25 10.1109 11.1709 9.97025 11.0303C9.82959 10.8896 9.75058 10.6989 9.75058 10.5C9.75058 10.3011 9.82959 10.1104 9.97025 9.96973C10.1109 9.82907 10.3017 9.75 10.5006 9.75H11.2506C11.6484 9.75 12.0299 9.90803 12.3112 10.1893C12.5926 10.4706 12.7506 10.8522 12.7506 11.25V15C12.7508 15.1988 12.83 15.3894 12.9706 15.53C13.1111 15.6706 13.3017 15.7497 13.5006 15.75H14.2506C14.4495 15.75 14.6403 15.8291 14.7809 15.9697C14.9216 16.1104 15.0006 16.3011 15.0006 16.5C15.0006 16.6989 14.9216 16.8896 14.7809 17.0303C14.6403 17.1709 14.4495 17.25 14.2506 17.25Z"
            fill="#00325C"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.38774 21.2765C6.53391 23.0377 9.22432 24.0001 12.0006 24C13.5771 24.0042 15.1387 23.6958 16.5951 23.0924C18.0516 22.4891 19.3739 21.6028 20.4856 20.485C22.4486 18.5218 23.6702 15.9387 23.9423 13.1758C24.2143 10.4129 23.5199 7.64111 21.9774 5.33278C20.4349 3.02445 18.1398 1.32242 15.483 0.516615C12.8263 -0.289192 9.97229 -0.148948 7.40739 0.913587C4.8425 1.97612 2.72535 3.89513 1.41673 6.34364C0.108109 8.79215 -0.311045 11.6187 0.230696 14.3416C0.772438 17.0645 2.24157 19.5154 4.38774 21.2765ZM6.1671 3.26954C7.89381 2.11579 9.92389 1.50001 12.0006 1.50001C14.7844 1.50319 17.4533 2.61043 19.4217 4.57887C21.3901 6.54731 22.4974 9.21622 22.5006 12C22.5006 14.0767 21.8848 16.1068 20.731 17.8335C19.5773 19.5602 17.9374 20.906 16.0188 21.7007C14.1001 22.4954 11.9889 22.7034 9.95213 22.2982C7.91533 21.8931 6.04442 20.893 4.57597 19.4246C3.10752 17.9561 2.10749 16.0853 1.70235 14.0485C1.2972 12.0117 1.50513 9.90045 2.29985 7.98182C3.09457 6.0632 4.44038 4.4233 6.1671 3.26954Z"
            fill="#00325C"
        />
    </svg>
</button>
<div class="info-container" aria-live="assertive" aria-atomic="true"></div>

<style>
    :host {
        font-family: Asap;
        display: inline-block;
        position: relative;
    }

    .sr-only {
        clip: rect(0 0 0 0);
        clip-path: inset(100%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }

    .info-button {
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        border-radius: 0.5rem;
        position: relative;
    }

    .info-button:hover,
    .info-button:focus {
        outline: 0.125rem solid var(--svea-interactive-primary-active, #115475);
    }

    .info-container {
        display: none;
        position: absolute;
        background: var(--svea-info-button-popup-bg, #ffffff);
        border: 1px solid var(--svea-info-button-popup-border, #cbcbcb);
        border-radius: 0.3rem;
        opacity: 0;
        box-shadow:
            0 0.5rem 0.313rem 0 #00000029,
            0 0.125rem 0.313rem 0 #00000029;
        color: var(--svea-info-button-popup-text, #434343);
        padding: var(--svea-info-button-popup-padding, 0.75rem 1rem);
        font-size: 0.875rem;
        pointer-events: none;
        width: 20rem;
        text-align: center;
        box-sizing: border-box;
        z-index: 10;
    }

    @media (max-width: 25rem) {
        .info-container {
            width: 16.875rem;
        }
    }

    @media (max-width: 20rem) {
        .info-container {
            width: 14rem;
        }
    }

    .info-container[position='top'] {
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 0.5rem;
    }

    .info-container[position='bottom'] {
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 0.5rem;
    }

    .info-container[position='left'] {
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 0.5rem;
    }

    .info-container[position='right'] {
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 0.5rem;
    }
</style>
`